import { Box, Typography } from "@mui/material";
import "../dossier-styles.scss";
import CustomProfil from "../../../Common/CustomProfil/CustomProfil";

export default function HeaderNewDossier({ back }: { back: Function }) {
    return (
        <Box
            sx={{
                display: "flex",

                flexDirection: "column",

                gap: "2.28rem",
                marginBottom: "1rem",
            }}
        >
            <Box>
                {/* <BackButton
                    back={() => {
                        back();
                    }}
                /> */}
                <CustomProfil />
            </Box>
            <Typography className="dossier-header-title">
                Nouveau dossier de qualification
            </Typography>
        </Box>
    );
}
